import { STATUS } from '@/app/api/constants.ts';
import { redirect } from '@tanstack/react-router';
import type { AxiosError } from 'axios';
import { authStore } from '@/app/localStorage/utils.ts';

export function handleUnauthorized(error: AxiosError) {
  if (error.status === STATUS.UNAUTHORIZED) {
    authStore.clear();
    throw redirect({ to: '/auth', replace: true });
  }
}
